import React, { Component, PropTypes } from 'react';
import Select from 'react-virtualized-select';

export default class EmailGroupFrequency extends Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
  }

  onChange(value) {
    this.props.onChange(value);
    this.props.updateSettings();
  }

  render() {
    const { frequencies, value } = this.props;

    return (<div className="row frequency-row">
      <div className="small-16 medium-3 column">
        <div className="frequency-label">Frequency</div>
        <span className="tag tag-default tag-sm">
          <Select
            onChange={this.onChange}
            options={frequencies}
            value={value}
            clearable={false}
            searchable={false}
            simpleValue={true}
          />
        </span>
      </div>
    </div>);
  }
}

EmailGroupFrequency.propTypes = {
  onChange: PropTypes.func.isRequired,
  frequencies: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.number,
  })),
  value: PropTypes.number,
  updateSettings: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./account/components/email_group_frequency.jsx